import React, { useRef } from "react";
import AppelAction from "../../components/AppelAction";
import SEOHead from "../../components/SEOHead";

// import styles from "./Features.module.sass";
import HeroEmargement from "./HeroEmargement";
import FonctionnalitesContrat from "./FonctionnalitesContrat";
import AvantagesGestion from "./AvantageGestion";  
import SolutionEmargement from "./SolutionEmargement";
import ExportEmargement from "./ExportEmargement";
import Faq from "./Faq";

const Emargement = () => {
  const scrollToRef = useRef(null);

  const seoData = {
    title: "Émargement & Assiduité - Suivi de présence numérique pour CFA | Edutio",
    description: "Simplifiez l'émargement avec Edutio. Solution numérique de suivi de présence en présentiel et distanciel. Signature électronique et conformité OPCO garantie.",
    keywords: "émargement numérique, suivi présence, assiduité alternants, CFA, formation professionnelle, signature électronique"
  };

  return (
    <>
      <SEOHead {...seoData} />
      <HeroEmargement  scrollToRef={scrollToRef} />
      <AvantagesGestion  className="section-pb" scrollToRef={scrollToRef} />
      <SolutionEmargement />
      <ExportEmargement />
      <FonctionnalitesContrat />
      <Faq />
      <AppelAction className="section" />
    </>
  );
};

export default Emargement;
